import { StyleSheet, Font } from "@react-pdf/renderer";

let pagefont = 11
let rowpagefont = pagefont - 1
Font.register({family: 'Roboto', src: "https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fCBc4EsA.woff2"})

export const styles = StyleSheet.create({
    page:{flexDirection: 'column',
    backgroundColor: 'white',
    fontFamily: 'Roboto'

    },

    letterView: {
        
        margin: 2.5,
        padding: 1,        
        alignItems: 'center'
    },
    letterheadLogo:{
        width: 320,
        height: 70,
        margin: 2.5,     
                },
    addressView:{
        alignItems: 'center',
        flexDirection: 'column',
        color: 'gray',
        fontSize: 14
        
        
    },
    address:{
        fontSize: pagefont,
        color: '#100c08',           
        marginBottom: pagefont,
        marginLeft: 16

    },
    afterAddress:{
        marginBottom: pagefont,
        marginLeft: 16
    },
    body:{
        color: '#100c08',
        fontSize: pagefont,
        marginLeft: 16,
        marginRight: 16,
        marginBottom: pagefont
    },
    subjectLine: {
         marginBottom: 12,
         fontWeight: 'bold',
         fontSize: 12,
         marginLeft: 16

    },
    accountsLine:{
        color: '#100c08',
        fontSize: 9,
        marginLeft: 16,
        marginRight: 16,
        marginBottom: pagefont,
        lineHeight: 1.5
    },
    signature:{
        width: 200,
        marginLeft: 16
        

    },
    signatureStart:{
        color: '#100c08',
        fontSize: pagefont,
        marginLeft: 16,
        marginRight: 16,
        marginTop: pagefont
    },
    signatureBlock:{
        color: '#100c08',
        fontSize: pagefont,
        marginLeft: 16,
        lineHeight: 1.2
    },
     row: {
        display: 'flex',
        flexDirection: 'row',
        color: '#100c08',
        fontSize: rowpagefont,
        marginLeft: 14,
        marginRight: 14,
        marginBottom: pagefont
    },
    bullet:{
        height: '100%',
        fontSize: pagefont,
    },
    indentAddress: {
        textIndent: 25,
        fontSize: rowpagefont,
        color: '#100c08'


    },
    mailto:{
        textIndent: 20,
        fontSize: rowpagefont,
        color: '#100c08'

    }


})


